import { render, staticRenderFns } from "./userManage.vue?vue&type=template&id=920228e8&"
import script from "./userManage.vue?vue&type=script&lang=js&"
export * from "./userManage.vue?vue&type=script&lang=js&"
import style0 from "./userManage.vue?vue&type=style&index=0&id=920228e8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports